export default "__VITE_ASSET__Dhg8pOZs__"